/** Pastilles de contenu dans les cellules de grille Data Manager (aligné Dispatch/Résultats). */
export const DATA_MANAGER_GRID_BADGE_RADIUS_CLASS_NAME = "rounded-[4px]";

export const DATA_MANAGER_GRID_ROW_BASE_CLASS_NAME = "transition-[background-color,box-shadow] duration-150";

export const DATA_MANAGER_GRID_ROW_HIGHLIGHT_CLASS_NAME = [
  "bg-[var(--color-legacy-teal-soft)]",
  "shadow-[inset_3px_0_0_0_var(--color-accent),inset_0_0_0_1px_rgba(15,92,87,0.38)]",
  "ring-1 ring-inset ring-accent/45",
].join(" ");

export const DATA_MANAGER_GRID_ROW_HIGHLIGHT_HOVER_CLASS_NAME = [
  "hover:bg-[var(--color-legacy-teal-soft)]",
  "hover:shadow-[inset_3px_0_0_0_var(--color-accent),inset_0_0_0_1px_rgba(15,92,87,0.38)]",
  "hover:ring-1 hover:ring-inset hover:ring-accent/45",
].join(" ");

const DATA_MANAGER_GRID_ROW_DRAFT_CLASS_NAME = "bg-amber-50/55";

const DATA_MANAGER_GRID_ROW_CANCELLED_CLASS_NAME = "opacity-60";

const DATA_MANAGER_GRID_ROW_PENDING_CLASS_NAME = "opacity-75";

const DATA_MANAGER_GRID_ROW_NORMAL_CLASS_NAME = [
  "odd:bg-slate-100",
  DATA_MANAGER_GRID_ROW_HIGHLIGHT_HOVER_CLASS_NAME,
].join(" ");

const DATA_MANAGER_GRID_ROW_INTERACTIVE_CLASS_NAME = "cursor-pointer";

export function buildDataManagerGridRowSelectionClassName({ isSelected = false, rowClassName = "" } = {}) {
  if (isSelected) {
    return [DATA_MANAGER_GRID_ROW_BASE_CLASS_NAME, DATA_MANAGER_GRID_ROW_HIGHLIGHT_CLASS_NAME].join(" ");
  }
  return rowClassName;
}

export function buildDataManagerGridRowClassName({
  isEditing = false,
  isFocused = false,
  hasDraft = false,
  isCancelled = false,
  isPending = false,
  canEnterEditMode = true,
} = {}) {
  const classNames = [DATA_MANAGER_GRID_ROW_BASE_CLASS_NAME];

  if (isEditing) {
    classNames.push(DATA_MANAGER_GRID_ROW_HIGHLIGHT_CLASS_NAME);
  } else if (hasDraft) {
    classNames.push(DATA_MANAGER_GRID_ROW_DRAFT_CLASS_NAME);
  } else if (isFocused) {
    classNames.push(DATA_MANAGER_GRID_ROW_HIGHLIGHT_CLASS_NAME);
  } else {
    classNames.push(DATA_MANAGER_GRID_ROW_NORMAL_CLASS_NAME);
  }

  if (isCancelled) {
    classNames.push(DATA_MANAGER_GRID_ROW_CANCELLED_CLASS_NAME);
  }

  if (isPending) {
    classNames.push(DATA_MANAGER_GRID_ROW_PENDING_CLASS_NAME);
  }

  if (canEnterEditMode && !isEditing) {
    classNames.push(DATA_MANAGER_GRID_ROW_INTERACTIVE_CLASS_NAME);
  }

  return classNames.join(" ");
}

export function handleDataManagerGridRowClick(onFocusRow) {
  if (typeof onFocusRow === "function") {
    onFocusRow();
  }
}

export function handleEditableGridKeyDown(event, { onCancel = null, onSubmit = null } = {}) {
  if (event.defaultPrevented || event.shiftKey || event.altKey || event.ctrlKey || event.metaKey) {
    return;
  }

  if (event.nativeEvent?.isComposing) {
    return;
  }

  const tagName = typeof event.target?.tagName === "string" ? event.target.tagName.toUpperCase() : "";
  if (tagName === "BUTTON" || tagName === "TEXTAREA") {
    return;
  }

  if (event.key === "Escape") {
    event.preventDefault();
    event.stopPropagation();
    onCancel?.();
    return;
  }

  if (event.key !== "Enter") {
    return;
  }

  event.preventDefault();
  event.stopPropagation();
  onSubmit?.();
}
